<template>
  <LeadHistoryCard 
    v-bind="attributes"
    :pick-up-call-target-id="pickUpCallTargetId"
    @update:pick-up-call-target-id="$emit('update:pickUpCallTargetId', $event)"
  >
    <template #date>
      <div>{{ historiedAt }}</div>
    </template>
  </LeadHistoryCard>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { CallTarget } from '@/api/openapi';
import LeadHistoryCard from '@/components/organisms/user/lead/history/LeadHistoryCard.vue';
import { SequenceInstanceHistory } from '@/store/types';
import { formatShorterDateTime } from '@/utils/date-time';

type TProps = {
  callTargetId: number;
  sequenceInstanceHistory: SequenceInstanceHistory;
  callTarget?: CallTarget;
};

const props = withDefaults(defineProps<TProps>(), {
  callTarget: undefined,
});
defineEmits<{
  'update:pickUpCallTargetId': [value: number];
}>();
defineOptions({
  inheritAttrs: false,
});

// v-model for pickUpCallTargetId to pass through to parent
const pickUpCallTargetId = defineModel<number>('pickUpCallTargetId');

const attributes = computed(() => ({
  text: title(),
  isDisplaySystemUser: true,
  iconComponent: 'BCustomIcon',
  customIconClass: 'b-sequence',
  iconType: 'hot',
  toggle: false,
  expand: false,
  callTargetId: props.callTargetId,
  callTarget: props.callTarget,
  history: props.sequenceInstanceHistory,
}));

const historiedAt = computed<string>(() => formatShorterDateTime(props.sequenceInstanceHistory.historiedAt));
const title = () => {
  return `${props.sequenceInstanceHistory.actionTypeText} - ${props.sequenceInstanceHistory?.name}`;
};
</script>

<style lang="scss" scoped>
:deep(.lead-history-expand-indicator) {
  height: 0;
}
</style>
